import { PageHeader } from '@components/page-header/page-header';
import { useChildEligibilities } from '@react-query/hooks/query/use-child-eligibilities';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';
import { HeaderIngressSkeleton } from './skeleton/header-ingress-skeleton';
import { useSessionName } from './use-session-name';

export const HeaderIngress = () => {
    const { header, ingress } = useTranslation();
    const { data: prettySessionName, isPending: isPendingSession } = useSessionName();
    const { data: childEligibilities, isPending: isPendingEligibilities } = useChildEligibilities();

    const isPending = isPendingSession || isPendingEligibilities;

    if (isPending) {
        return <HeaderIngressSkeleton header={header} />;
    }

    if (!childEligibilities || childEligibilities.length === 0) {
        return <PageHeader header={header} />;
    }

    return <PageHeader header={header} ingress={format(ingress, prettySessionName ? ` ${prettySessionName}` : '')} />;
};
